export function emitNotificationSound(audioPath = '/audio/swiftly.mp3'): void {
  try {
    const audio = new Audio(audioPath);
    audio.load();
    audio.play();
  } catch (error) {
    // ignore
  }
}
